export const classes = {
  card: 'flex flex-col min-w-0 px-[22px] py-5',
  titleWrapper: 'flex justify-between items-start gap-4 mb-3',
  title: 'text-[16px] font-bold text-taupe-3',
  subtitle: 'mt-0.5 text-[12.5px] text-taupe-2',
  buttonsWrapper: 'flex justify-start items-start shrink-0',
  infoIcon: 'text-2xl text-taupe-1 cursor-pointer',
  exportIcon: 'text-taupe-2',
  body: 'flex flex-col grow min-w-0 overflow-x-auto',
  loadingMessage: 'h-48 w-full place-center text-lg font-light text-taupe-1',
};
